// extracted by mini-css-extract-plugin
module.exports = {"PriceBox":"Prices_PriceBox__QL1VX","Price":"Prices_Price__2qMgp","OldPrice":"Prices_OldPrice__LP0EE","NewPrice":"Prices_NewPrice__1cHa9"};